import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_department",
  "use": "icon-control_department-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_department\"><g transform=\"translate(2 2)\" stroke=\"currentColor\" fill=\"transparent\"><path d=\"M4.78 10.5H1.6C.716 10.5 0 9.816 0 8.973V1.527C0 .684.716 0 1.6 0h6.8c.884 0 1.6.684 1.6 1.527V3.37\" stroke-linecap=\"round\" /><circle cx=\"9.25\" cy=\"6.25\" r=\"1.25\" /><path d=\"M12 11c0-1.657-1.231-3-2.75-3S6.5 9.343 6.5 11M2.5 6.24h3M2.5 3.25h5\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol